export const REASON_LABELS: Record<string, string> = {
  non_trusted_seller: 'Vendedor no confiable',
  reputation_below_threshold: 'Reputación baja',
  item_reputation_below_threshold: 'Reputación del listing baja',
  winner_has_better_reputation: 'Competidor con mejor reputación',
  manufacturing_time: 'Tiene tiempo de fabricación',
  temporarily_winning_manufacturing_time: 'Ganando provisional (manufactura)',
  temporarily_competing_manufacturing_time: 'Compitiendo provisional (manufactura)',
  temporarily_winning_best_reputation_available: 'Ganando provisional (mejor reputación disponible)',
  temporarily_competing_best_reputation_available: 'Compitiendo provisional (mejor reputación disponible)',
  item_paused: 'Item pausado',
  item_not_opted_in: 'No participa del catálogo',
  shipping_mode: 'Modo de envío inferior al ganador',
};

export const BOOST_LABELS: Record<string, string> = {
  fulfillment: 'Mercado Envíos Full',
  free_installments: 'Cuotas sin interés',
  free_shipping: 'Envío gratis',
  same_day_shipping: 'Envío en el día',
  shipping_collect: 'Envíos Colecta',
};

export function statusBadge(status: string | null): { label: string; color: string; emoji: string } {
  switch (status) {
    case 'winning':
      return { label: 'Ganando', color: 'var(--color-success)', emoji: '🟢' };
    case 'sharing_first_place':
      return { label: 'Comparte 1er puesto', color: 'var(--color-success)', emoji: '🟡' };
    case 'competing':
    case 'losing':
      return { label: 'Perdiendo', color: 'var(--color-error)', emoji: '🔴' };
    case 'not_listed':
    case 'listed':
      return { label: 'No compite', color: 'var(--color-text-muted)', emoji: '⚪' };
    case 'no_competition':
      return { label: 'Sin competencia', color: 'var(--color-text-muted)', emoji: '⚪' };
    default:
      return { label: status || 'Sin datos', color: 'var(--color-text-muted)', emoji: '⚪' };
  }
}
